var _regeneratorRuntime = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/regenerator");
var _asyncToGenerator = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/helpers/asyncToGenerator");
var postcss = require('postcss');
var processResult = require('./process-result');
var parse = require('./parser');
module.exports = function async(plugins) {
  var processor = postcss(plugins);
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return processor.process(input, {
                parser: parse,
                from: undefined
              });
            case 2:
              result = _context.sent;
              return _context.abrupt("return", processResult(result));
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};